import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, " IMPRESSUM ", -1)
const _hoisted_2 = { class: "pt-3 impressum" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "pr-5" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Hangover Bar"),
  /*#__PURE__*/_createElementVNode("p", null, "Karlsplatz 3"),
  /*#__PURE__*/_createElementVNode("p", null, "71638 Ludwigsburg"),
  /*#__PURE__*/_createElementVNode("p", null, "Tel. 07141 / 4873271"),
  /*#__PURE__*/_createElementVNode("p", null, "E-Mail: info@hangover-lb.de")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Inhaber: Ramez Salim"),
  /*#__PURE__*/_createElementVNode("p", null, "Steuernummer: 71217/46678")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_footer = _resolveComponent("v-footer")!

  return (_openBlock(), _createBlock(_component_v_footer, {
    id: "impressum",
    class: "text-center d-flex flex-column footer"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.icons, (icon) => {
            return (_openBlock(), _createBlock(_component_v_btn, {
              key: icon,
              class: "mx-4",
              icon: icon,
              variant: "text",
              href: _ctx.socialLink(icon)
            }, null, 8, ["icon", "href"]))
          }), 128))
        ]),
        _hoisted_3,
        _hoisted_4
      ])
    ]),
    _: 1
  }))
}